import { render } from "./PageFooter.vue?vue&type=template&id=659db370&ts=true"
import script from "./PageFooter.vue?vue&type=script&lang=ts"
export * from "./PageFooter.vue?vue&type=script&lang=ts"

import "./PageFooter.vue?vue&type=style&index=0&id=659db370&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__